import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Spin } from "antd";
import { LoaderSpinner } from "./Components/Loader/Loader";
import ErrorBoundary from "./Components/Common/ErrorBoundary";
import config from "./config";
// Side-effect import: registers global axios timeout + response interceptor (N-07)
import "./services/apiClient";

// S-31: in production, silence `console.log/debug/info/warn` globally so any
// stray dev-debug statements (tokens, OAuth codes, API payloads) don't leak
// to the devtools console. `console.error` is retained for genuine errors.
// This is a belt-and-suspenders safety net alongside the `logger` module —
// the per-call migration to `logger.*` can proceed incrementally without
// leaving a production-leakage window in the meantime.
if (process.env.NODE_ENV === "production") {
  const noop = () => {};
  // eslint-disable-next-line no-console
  console.log = noop;
  // eslint-disable-next-line no-console
  console.debug = noop;
  // eslint-disable-next-line no-console
  console.info = noop;
  // eslint-disable-next-line no-console
  console.warn = noop;
}

// Stripe publishable key sourced from env (S-08). Never hardcode pk_test_* here.
// One loader app-wide: every antd <Spin>, <Table loading>, <Card loading> uses it.
Spin.setDefaultIndicator(<LoaderSpinner size={40} />);

// If js.stripe.com is unreachable (offline, DNS failure, ad/privacy blocker),
// loadStripe rejects and the unhandled rejection surfaces as an "Uncaught
// runtime error" overlay in dev. Resolve to null instead so the rest of the
// app still renders; <Elements stripe={null}> simply disables Stripe features.
const stripePromise = loadStripe(config.stripe.publishableKey).catch((err) => {
  // eslint-disable-next-line no-console
  console.error("Stripe.js failed to load; payment features are disabled.", err);
  return null;
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
    // {/* <ErrorBoundary> */}
      <Provider store={store}>
        <GoogleOAuthProvider clientId={config.google.clientId}>
          <ToastContainer />
          <Elements stripe={stripePromise}>
            <App />
          </Elements>
        </GoogleOAuthProvider>
      </Provider>
    // {/* </ErrorBoundary> */}
  // </React.StrictMode>
);

// web-vitals v4 reporter wired to the logger (S-35, S-54).
reportWebVitals();
